import { Spin } from 'antd';
import classNames from 'classnames';
import { CustomSpinProps } from '../../interfaces';
import './styles.scss';

const CustomSpin: React.FC<CustomSpinProps> = props => {
  const { className, ...rest } = props;
  return <Spin {...rest} className={classNames(className, 'custom-spin')} />;
};

export default CustomSpin;
